module.exports = __webpack_public_path__ + "static/media/celualr@2x.7f0786ae.png";